import { useMemo } from 'react';

import usePersonalInformationFields from '../PersonalInformation/hooks/usePersonalInformationFields';
import useRegistrationAndLoginFields from '../RegistrationAndLogin/hooks/useRegistrationAndLoginFields';

export default () => {
  const personalInformationFields = usePersonalInformationFields();
  const registrationAndLoginFields = useRegistrationAndLoginFields();

  const fields = useMemo(() => [...personalInformationFields, ...registrationAndLoginFields],
    [personalInformationFields, registrationAndLoginFields]);

  return fields;
};
